import './assigned-courses.scss';
import "../applicants/applicants.scss";
import {useQueryAssignedCourses} from "../../../api/admin/useQueryAssignedCourses";
import Search from "../../../components/UI/Search/Search";
import ComplexSearch from "../../../components/UI/ComplexSearch/ComplexSearch";
import {IProgram} from "../../../constants/types/IProgram";
import {applicantsSortingOptions} from "../../../constants/ui/sortingOptions";
import {PermissionType} from "../../../constants/types/PermissionType";
import {IUser, UserContext} from "../../../hooks/Context/UserContext";
import {DropdownOption} from "../../../components/UI/SearchAndSort/DropdownWithIcon/Sorting";
import FilterIcon from "../../../assets/icons/UI/icons/filter.svg";
import {useContext, useEffect, useState} from "react";
import {useQueryClient} from "@tanstack/react-query";
import {useNavigate} from "react-router-dom";
import {ISortingOption} from "../../../components/UI/SearchAndSort/SearchAndSort";
import {useQueryPrograms} from "../../../api/admin/useQueryPrograms";
import {useQueryAdmins} from "../../../api/admin/useQueryAdmins";
import Loading from "../../../components/UI/Loading/Loading";
import {ActiveApplicantsTable} from "../applicants/ApplicantsList";
import AssignedCoursesTable from "./AssignedCousesTable";

const AssignedCourses = () => {

  const [user] = useContext(UserContext);
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [activeSearchParam, setActiveSearchParam] = useState<string>("");
  const [activePage, setActivePage] = useState<number>(1);
  const [sortingValue, setSortingValue] = useState<ISortingOption>(
    applicantsSortingOptions[2]
  );
  const [filterValue, setFilterValue] = useState<ISortingOption[]>([]);
  const [hideReviewComplete, setHideReviewComplete] = useState<boolean>(false);
  const [assignedTo, setAssignedTo] = useState<IUser>({});

  const {data: programs, isLoading: programsIsLoading} = useQueryPrograms({
    name_only: true,
  });

  const {data: adminsList, refetch: refetchAdminList} = useQueryAdmins();

  useEffect(() => {
    if (user.permission_groups?.includes(PermissionType.cpl_super_admin)) {
      refetchAdminList();
    }
  }, [user, refetchAdminList]);

  useEffect(() => {
    if (activeSearchParam.length > 2 || activeSearchParam.length === 0) {
      setActivePage(1);
      queryClient.invalidateQueries({
        queryKey: ["applicants"],
        exact: true,
      });
    }
  }, [activeSearchParam]);

  useEffect(() => {
    queryClient.invalidateQueries({
      queryKey: ["applicants"],
      exact: true,
    });
  }, [activePage]);

  useEffect(() => {
    setActivePage(1);
    queryClient.invalidateQueries({
      queryKey: ["applicants"],
      exact: true,
    });
  }, [sortingValue, filterValue, assignedTo, hideReviewComplete]);


  if (programsIsLoading) {
    return <Loading loading/>;
  }

  return <div className={'applicants assigned-courses'}>
    <div className="assigned-courses-title">
      Assigned Courses
    </div>

    <ComplexSearch
      search={{
        value: activeSearchParam,
        onChange: (e) => setActiveSearchParam(e.target.value),
        placeholder: "Search"
      }}
      toggle={[
        {
          active: hideReviewComplete,
          onToggle: () =>
            setHideReviewComplete(!hideReviewComplete),
          label: "Hide review completed",
        },
      ]}
    />
    <AssignedCoursesTable
      searchParam={activeSearchParam}
      page={activePage}
      sortingValue={sortingValue}
      filterValue={filterValue}
      hideReviewComplete={hideReviewComplete}
      onPageChange={(page) => {
        setActivePage(page);
        window.scroll(0, 0);
      }}
      navigate={navigate}
      queryClient={queryClient}
    />


  </div>
}

export default AssignedCourses;